import { render, staticRenderFns } from "./PortalsIndex.vue?vue&type=template&id=28e684ed"
import script from "./PortalsIndex.vue?vue&type=script&lang=js"
export * from "./PortalsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports